import CryptoJS from "crypto-js";
import crypto from "crypto";

export const decryptAES128CBC = (message, key, iv) => {
  try {
    return CryptoJS.AES.decrypt(message, CryptoJS.enc.Utf8.parse(key), {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error({ decryptAES128CBC: error });
  }
};
export const decryptV8_CBC = (message) => {
  const date = getDateNowFormatYYMMDDHHMNSS().substr(0, 8);
  const date2 = getDateNowFormatMMDDYY().substr(0, 8);
  const vector_id = process.env.REACT_APP_VECTOR_INITIALIZATION_CLARO_ID;
  const secret = process.env.REACT_APP_KEY_CLARO_ID + date;
  const iv = intercalarCadena(vector_id, date2);
  return decryptAES128CBC(message, secret, iv);
};

export const decryptAES256CBC = (message, secretKey, iv) => {
  try {
    const decipher = crypto.createDecipheriv(
      "aes-256-cbc",
      Buffer.from(secretKey, "utf-8"), // Asegurar clave en formato buffer
      Buffer.from(iv, "utf-8") // Asegurar IV en formato buffer
    );

    let decrypted = decipher.update(message, "base64", "utf-8"); // Decodifica base64 y desencripta
    decrypted += decipher.final("utf-8"); // Finaliza la desencriptación
    return decrypted;
  } catch (error) {
    console.error("Error during decryption:", error.message);
    throw error;
  }
};

export const decryptV8_3 = (message) => {
  const secretKey = process.env.REACT_APP_KEY_CLARO_ID; // Clave de 32 bytes
  const iv = process.env.REACT_APP_VECTOR_INITIALIZATION_CLARO_ID; // IV de 16 bytes
  return decryptAES256CBC(message, secretKey, iv);
};
//////////////////////////////////////////////////////////////////////////////////////

export const decryptV8_ECB = (message) => {
  try {
    // Validar si el mensaje está en Base64
    if (!isBase64(message)) {
      throw new Error("El mensaje no está en formato Base64 válido.");
    }

    // Generar la clave con la fecha en formato yyyyMMdd
    const date = new Date();
    const yyyyMMdd = date.toISOString().split("T")[0].replace(/-/g, "");
    const secretKey = 'MICLAROA' + yyyyMMdd; // Clave de 16 bytes
    console.log("Clave secreta generada:", secretKey);

    return decryptAES128ECB(message, secretKey); // Usar ECB
  } catch (error) {
    console.error("Error en la función decryptV8:", error.message);
    throw error;
  }
};

// Función para desencriptar un mensaje utilizando AES-128-ECB
export const decryptAES128ECB = (message, secretKey) => {
  const key = CryptoJS.enc.Utf8.parse(secretKey);
  const decrypted = CryptoJS.AES.decrypt(message, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

// Función para validar si el mensaje es un Base64 válido
const isBase64 = (str) => {
  const regex = /^[A-Za-z0-9+/=]+$/;
  return regex.test(str);
};

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function intercalarCadena(cadena1, cadena2) {
  let resultado = "";
  const longitudMaxima = Math.max(cadena1.length, cadena2.length);

  for (let i = 0; i < longitudMaxima; i++) {
    if (i < cadena1.length) {
      resultado += cadena1[i];
    }
    if (i < cadena2.length) {
      resultado += cadena2[i];
    }
  }
  return resultado;
}

export const getDateNowFormatYYMMDDHHMNSS = () => {
  const now = Date.now();
  const dateNow = new Date(now);
  const yy = dateNow.getFullYear().toString();
  const mm = `${dateNow.getMonth() + 1 <= 9 ? "0" : ""}${
    dateNow.getMonth() + 1
  }`;
  const dd = `${dateNow.getDate() <= 9 ? "0" : ""}${dateNow.getDate()}`;
  const hh = `${dateNow.getHours() <= 9 ? "0" : ""}${dateNow.getHours()}`;
  const mn = `${dateNow.getMinutes() <= 9 ? "0" : ""}${dateNow.getMinutes()}`;
  const ss = `${dateNow.getSeconds() <= 9 ? "0" : ""}${dateNow.getSeconds()}`;

  return `${yy}${mm}${dd}${hh}${mn}${ss}`;
};

const getDateNowFormatMMDDYY = () => {
  const now = Date.now();
  const dateNow = new Date(now);
  const yy = dateNow.getFullYear().toString();
  const mm = `${dateNow.getMonth() + 1 <= 9 ? "0" : ""}${
    dateNow.getMonth() + 1
  }`;
  const dd = `${dateNow.getDate() <= 9 ? "0" : ""}${dateNow.getDate()}`;

  return `${mm}${dd}${yy}`;
};
